import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../../config/api";
import { BASE_API } from "../../../../../constants/apiUrls";
import { toast } from "../../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../../types";
import { BecomePartnerData } from "../../../../../types/webCms/aboutUs/become";

// get all
export const getAllBecomePartnerAsync = createAsyncThunk<
  GetCommonData<BecomePartnerData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllBecomePartner", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomeBecomePartner);

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get fail");
    return rejectWithValue(error);
  }
});

// update
export const updateBecomePartnerAsync = createAsyncThunk<
  null,
  PostRequest<BecomePartnerData, any>
>(
  "admin/updateBecomePartner",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomeBecomePartner}`, data);

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "update fail");
      return rejectWithValue(error);
    }
  }
);
